import { IconPropsType } from "./type";

export const Pnpm = ({ size = 24 }: IconPropsType) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    viewBox="66.09157809474142 33.5 184.5 184.49999999999997"
    width={size}
    height={size}
  >
    <defs>
      <path
        d="M67.59 35L247.59 35L247.59 215L67.59 215L67.59 35Z"
        id="b2JZZcA3fT"
      />
      <path d="M237.6 95L187.6 95L187.6 45L237.6 45L237.6 95Z" id="bj0tb0Y8q" />
      <path
        d="M182.59 95L132.59 95L132.59 45L182.59 45L182.59 95Z"
        id="dkDSTzPj3"
      />
      <path
        d="M127.59 95L77.59 95L77.59 45L127.59 45L127.59 95Z"
        id="a4vNdcNLpF"
      />
      <path
        d="M237.6 150L187.6 150L187.6 100L237.6 100L237.6 150Z"
        id="h2t4Zj1jSU"
      />
      <path
        d="M182.59 150L132.59 150L132.59 100L182.59 100L182.59 150Z"
        id="b4t5pngwvT"
      />
      <path
        d="M182.59 205L132.59 205L132.59 155L182.59 155L182.59 205Z"
        id="b9s1gd5m2"
      />
      <path
        d="M237.6 205L187.6 205L187.6 155L237.6 155L237.6 205Z"
        id="cmt9WLvz7"
      />
      <path
        d="M127.59 205L77.59 205L77.59 155L127.59 155L127.59 205Z"
        id="bJUNqgFSg"
      />
    </defs>
    <g>
      <g>
        <use
          xlinkHref="#b2JZZcA3fT"
          opacity="1"
          fill="#ffffff"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#bj0tb0Y8q"
          opacity="1"
          fill="#f9ad00"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#dkDSTzPj3"
          opacity="1"
          fill="#f9ad00"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#a4vNdcNLpF"
          opacity="1"
          fill="#f9ad00"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#h2t4Zj1jSU"
          opacity="1"
          fill="#f9ad00"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#b4t5pngwvT"
          opacity="1"
          fill="#4e4e4e"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#b9s1gd5m2"
          opacity="1"
          fill="#4e4e4e"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#cmt9WLvz7"
          opacity="1"
          fill="#4e4e4e"
          fillOpacity="1"
        />
      </g>
      <g>
        <use
          xlinkHref="#bJUNqgFSg"
          opacity="1"
          fill="#4e4e4e"
          fillOpacity="1"
        />
      </g>
    </g>
  </svg>
);
